// extracted by mini-css-extract-plugin
export var centerText = "_du-8";
export var container = "_du-0";
export var doughnutContainer = "_du-7";
export var legend = "_du-a";
export var legendItemColorDisplay = "_du-b";
export var legendItemLabel = "_du-d";
export var legendItemValue = "_du-c";
export var lg = "_du-5";
export var maxWidth = "_du-9";
export var md = "_du-4";
export var responsive = "_du-6";
export var sm = "_du-3";
export var xs = "_du-2";
export var xxs = "_du-1";